import { MovieClip } from '@play-co/timestep-core/ui';
import { ButtonScaleViewOpts } from 'src/lib/ui/components/ButtonScaleView';
import { now, user } from 'src/StateObserver';
import {
  magicLampsGetRemainingTime,
  magicLampsIsAvailable,
} from 'src/replicant/match2/magiclamps/magiclamps.getters';
import { AssetGroup } from '@play-co/timestep-core';
import { FeatureButton } from 'src/game/components/FeatureButton';

const assets = {
  movieclip: {
    url: 'assets/ui/match2/magiclamps/button',
    loadMethod: MovieClip.animationLoader,
  },
};

export class MagicLampsButtonAnimated extends FeatureButton {
  constructor(opts: ButtonScaleViewOpts) {
    super({
      width: 144,
      height: 175,
      pressedOffsetY: 5,
      labelPanel: {
        offsetY: -10,
      },
      ...opts,
    });

    this.animationStateMap = {
      main: {
        type: 'movieclip',
        assetGroup: new AssetGroup(Object.values(assets)),
        url: assets.movieclip.url,
        sequence: ['magic_lamp_spawn', 'magic_lamp_loop'],
        scale: 0.65,
      },
    };
  }

  public update() {
    // Check if magic lamps feature is active and if there is an ongoing event.
    // Hide the button if not.
    if (!magicLampsIsAvailable(user(), now())) {
      this.hide();
      return;
    }

    // Show the button if the magic lamps become available
    this.show();
    this.setLabelTime({ duration: magicLampsGetRemainingTime(now()) });
    this.setAnimationState('main');
  }
}
